import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-apollo'
import classnames from 'classnames'
import { path, isNil } from 'ramda'

import { getResponsiveTileShowCount } from '../../../../../lib/utils'
import { useScreenWidth } from '../../../../../hooks/use-screen-width'
import EmblaCarousel from '../../../../emblaCarousel'
import { getTileRecipe } from '../../../../imgix/recipes'
import Tile from './carousel/tile'
import CloseIcon from './close-icon'
import { StateConsumer } from '../../../state'
import MORE_LIKE_THIS_QUERY from './more-like-this.gql'
import styles from './more-like-this-ui.css'

const MoreLikeThis = ({ showpageUrl, dismissMoreLikeThis }) => {
  const screenWidth = useScreenWidth()
  const { loading, error, data } = useQuery(MORE_LIKE_THIS_QUERY, {
    variables: { screenId: showpageUrl }
  })

  if (loading || error) {
    return null
  }

  const carousel = path(['screen', 'components', 1], data)
  const tiles = path(['tiles'], carousel) || []

  if (isNil(carousel) || tiles.length === 0) {
    return null
  }

  const type = carousel.contentType || carousel.subType || 'Series'
  const recipe = getTileRecipe(type)
  const tileCount = getResponsiveTileShowCount(screenWidth, 2)

  return (
    <StateConsumer>
      {({ isAdOnPauseShown, isEpisodeSelectorOpen }) => (
        <div
          className={classnames(styles.wrapper, {
            [styles.show]: !isAdOnPauseShown && !isEpisodeSelectorOpen
          })}
        >
          <div className={styles.header}>
            <h2 className={styles.title}>{carousel.header}</h2>
            <CloseIcon
              className={styles.close}
              onClick={dismissMoreLikeThis}
            />
          </div>

          <div className={styles.carouselWrapper}>
            <EmblaCarousel
              slidesToShow={tileCount}
              activeSlideCount={tiles.length}
            >
              {tiles.map((tile, index) => (
                <div
                  className={styles.emblaSlide}
                  key={tile.id || tile.image || index}
                >
                  <Tile
                    tile={tile}
                    recipe={recipe}
                    listTitle={carousel.header}
                    index={index}
                  />
                </div>
              ))}
            </EmblaCarousel>
          </div>
        </div>
      )}
    </StateConsumer>
  )
}

MoreLikeThis.propTypes = {
  showpageUrl: PropTypes.string.isRequired,
  dismissMoreLikeThis: PropTypes.func.isRequired
}

export default MoreLikeThis
